import { Box, Typography } from "@mui/material";
import TransactionsTable from "./table";

const TransactionsListPage = () => {
  return (
    <Box p={"30px"}>
      <Typography mb={{xs: 2, md :4}} fontSize={"22px"} fontWeight={600}>
        Transactions List
      </Typography>
      <TransactionsTable />
    </Box>
  );
};

export default TransactionsListPage;
